import { oc } from '@orpc/contract';
import { changePasswordInputSchema, tokensOutputSchema } from '../schemas/auth.schemas.js';
/**
 * Returns a **fresh token pair**, not merely the user: changing your own password clears the
 * password-change-required flag and bumps the token version, so the tokens the caller is holding — which
 * carry `pwc: true` and the old version — stop working the moment this call succeeds (plan §2.3).
 */
export const changePasswordContract = oc
    .route({
    method: 'POST',
    path: '/auth/change-password',
    tags: ['Auth'],
    summary: 'Change your own password and receive a fresh token pair',
})
    .input(changePasswordInputSchema)
    .output(tokensOutputSchema);
//# sourceMappingURL=change-password.contract.js.map